import { createContext, useContext, type PropsWithChildren, type ReactElement } from 'react';
import useCorporateBondScreenerDictionaries, {
  type IUseCorporateBondScreenerDictionariesProps,
} from './useCorporateBondScreenerDictionaries';

type CorporateBondScreenerDictionariesContextType = ReturnType<typeof useCorporateBondScreenerDictionaries>;

const CorporateBondScreenerDictionariesContext =
  createContext<CorporateBondScreenerDictionariesContextType | null>(null);

export const useCorporateBondScreenerDictionariesContext = (): CorporateBondScreenerDictionariesContextType => {
  const context = useContext(CorporateBondScreenerDictionariesContext);

  if (!context) {
    throw new Error('useCorporateBondScreenerDictionariesContext must be used within CorporateBondScreenerDictionariesProvider');
  }

  return context;
};

interface IProps extends PropsWithChildren {
  dictionaries: IUseCorporateBondScreenerDictionariesProps,
}

export const CorporateBondScreenerDictionariesProvider = ({ children, dictionaries }: IProps): ReactElement => (
  <CorporateBondScreenerDictionariesContext.Provider value={ useCorporateBondScreenerDictionaries(dictionaries) }>
    { children }
  </CorporateBondScreenerDictionariesContext.Provider>
);
